import { useI18n, LanguageSwitcher } from "@/i18n";

export function SupportPage() {
  const { t } = useI18n();

  return (
    <div className="support-page">
      {/* Language Switcher */}
      <div className="page-language-switcher">
        <LanguageSwitcher />
      </div>

      <div className="support-container">
        <header className="support-header">
          <a href="/" className="back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            {t.common.backToHome}
          </a>
          <h1>{t.support.title}</h1>
          <p className="support-subtitle">{t.support.subtitle}</p>
        </header>

        <div className="support-content">
          {/* Contact Section */}
          <section className="support-section">
            <h2>{t.support.contactTitle}</h2>
            <p>{t.support.contactDesc}</p>
            <a href="mailto:support@govilo.xyz" className="support-email">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              support@govilo.xyz
            </a>
            <p className="response-time">{t.support.responseTime}</p>
          </section>

          {/* Getting Started Section */}
          <section className="support-section">
            <h2>{t.support.gettingStartedTitle}</h2>

            {/* Wallet */}
            <div className="guide-block">
              <h3>{t.support.walletTitle}</h3>
              <p>{t.support.walletDesc}</p>
              <div className="wallet-links">
                <a href="https://www.coinbase.com/wallet" target="_blank" rel="noopener noreferrer" className="wallet-link wallet-link-recommended">
                  <span className="wallet-badge">{t.support.walletLink1Badge}</span>
                  <div className="wallet-link-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" fill="#0052FF"/>
                      <path d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM10.5 10.5H13.5V13.5H10.5V10.5Z" fill="white"/>
                    </svg>
                  </div>
                  <div className="wallet-link-content">
                    <span className="wallet-link-name">{t.support.walletLink1}</span>
                    <span className="wallet-link-desc">{t.support.walletLink1Desc}</span>
                  </div>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                </a>
                <a href="https://metamask.io/download/" target="_blank" rel="noopener noreferrer" className="wallet-link">
                  <div className="wallet-link-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M21.3 3L13.1 9.2L14.6 5.5L21.3 3Z" fill="#E17726"/>
                      <path d="M2.7 3L10.8 9.3L9.4 5.5L2.7 3Z" fill="#E27625"/>
                      <path d="M18.4 16.7L16.3 20L20.8 21.2L22 16.8L18.4 16.7Z" fill="#E27625"/>
                      <path d="M2 16.8L3.2 21.2L7.7 20L5.6 16.7L2 16.8Z" fill="#E27625"/>
                      <path d="M7.5 10.8L6.3 12.6L10.8 12.8L10.6 8L7.5 10.8Z" fill="#E27625"/>
                      <path d="M16.5 10.8L13.3 7.9L13.2 12.8L17.7 12.6L16.5 10.8Z" fill="#E27625"/>
                      <path d="M7.7 20L10.5 18.6L8.1 16.8L7.7 20Z" fill="#E27625"/>
                      <path d="M13.5 18.6L16.3 20L15.9 16.8L13.5 18.6Z" fill="#E27625"/>
                    </svg>
                  </div>
                  <div className="wallet-link-content">
                    <span className="wallet-link-name">{t.support.walletLink2}</span>
                    <span className="wallet-link-desc">{t.support.walletLink2Desc}</span>
                  </div>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Base */}
            <div className="guide-block">
              <h3>{t.support.baseTitle}</h3>
              <p>{t.support.baseDesc}</p>
              <a href="https://base.org" target="_blank" rel="noopener noreferrer" className="learn-more-link">
                {t.support.baseLink}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </a>
            </div>

            {/* USDC */}
            <div className="guide-block">
              <h3>{t.support.usdcTitle}</h3>
              <p>{t.support.usdcDesc}</p>
              <a href="https://www.circle.com/usdc" target="_blank" rel="noopener noreferrer" className="learn-more-link">
                {t.support.usdcLink}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </a>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="support-section">
            <h2>{t.support.faqTitle}</h2>

            <div className="faq-list">
              <details className="faq-item">
                <summary>{t.support.faq1Question}</summary>
                <p>{t.support.faq1Answer}</p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq8Question}</summary>
                <p>{t.support.faq8Answer}</p>
                <p className="faq-link">
                  <a href={t.support.faq8LinkUrl} target="_blank" rel="noopener noreferrer">
                    {t.support.faq8Link} →
                  </a>
                </p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq2Question}</summary>
                <p>{t.support.faq2Answer}</p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq3Question}</summary>
                <p>{t.support.faq3Answer}</p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq4Question}</summary>
                <p>{t.support.faq4Answer}</p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq5Question}</summary>
                <p>{t.support.faq5Answer}</p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq6Question}</summary>
                <p>{t.support.faq6Answer}</p>
              </details>

              <details className="faq-item">
                <summary>{t.support.faq7Question}</summary>
                <p>{t.support.faq7Answer}</p>
              </details>
            </div>
          </section>

          {/* Report Section */}
          <section className="support-section">
            <h2>{t.support.reportTitle}</h2>
            <p>{t.support.reportDesc}</p>
            <ul className="report-list">
              <li>{t.support.reportItem1}</li>
              <li>{t.support.reportItem2}</li>
              <li>{t.support.reportItem3}</li>
            </ul>
            <p className="report-include-title">{t.support.reportInclude}</p>
            <ul className="report-list">
              <li>{t.support.reportIncludeItem1}</li>
              <li>{t.support.reportIncludeItem2}</li>
              <li>{t.support.reportIncludeItem3}</li>
            </ul>
            <p className="report-note">{t.support.reportNote}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
